import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const AREAS = [
    "Paris 7ème",
    "Paris & petite couronne",
    "Hauts-de-Seine (92)",
    "Yvelines (78)",
    "Val-de-Marne (94)",
    "Seine-Saint-Denis (93)",
    "Essonne (91)",
    "Val-d'Oise (95)",
    "Seine-et-Marne (77)",
    "Oise (60)",
    "Eure-et-Loir (28)",
    "Neuilly · Boulogne · Saint-Cloud",
    "Versailles · Saint-Germain",
];

export default function Footer() {
    const [year, setYear] = useState(new Date().getFullYear());
    useEffect(() => setYear(new Date().getFullYear()), []);

    return (
        <footer
            data-testid="footer"
            className="bg-[#1C1E1D] text-[#FAF9F6] pt-24 pb-10"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-16 border-b border-[#FAF9F6]/15">
                    <div className="md:col-span-2">
                        <img
                            src="https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/a3np66il_IMG_20250212_155956.jpg"
                            alt="CM RENOV — rénovation et construction Île-de-France"
                            className="h-16 w-auto object-contain bg-[#FAF9F6] p-2"
                        />
                        <p className="mt-6 text-[14px] text-[#FAF9F6]/60 max-w-md leading-relaxed italic font-serif-lux text-lg">
                            « Construire votre rêve, rénover votre réalité. »
                        </p>
                        <p className="mt-3 text-[13px] text-[#FAF9F6]/50 max-w-md leading-relaxed">
                            Entreprise de rénovation haut de gamme et construction de maisons individuelles à Paris 7ème et en Île-de-France. Fondée en 2024, portée par 20 ans d'expérience BTP.
                        </p>
                    </div>
                    <div>
                        <div className="tracking-luxe text-[#B89C6A] mb-4">
                            Adresse
                        </div>
                        <p className="text-[14px] text-[#FAF9F6]/70 leading-relaxed">
                            61 Avenue de Breteuil
                            <br />
                            75007 Paris
                        </p>
                    </div>
                    <div>
                        <div className="tracking-luxe text-[#B89C6A] mb-4">
                            Contact
                        </div>
                        <a
                            href="tel:+33623762847"
                            className="text-[15px] text-[#FAF9F6] hover:text-[#B89C6A] block mb-2 font-serif-lux"
                        >
                            06 23 76 28 47
                        </a>
                        <a
                            href="mailto:contact@cmrenov.com"
                            className="text-[13px] text-[#FAF9F6]/70 hover:text-[#B89C6A]"
                        >
                            contact@cmrenov.com
                        </a>
                    </div>
                </div>

                {/* Zones desservies — SEO local */}
                <div className="py-10 border-b border-[#FAF9F6]/10">
                    <div className="tracking-luxe text-[#B89C6A] mb-4">
                        Zones d'intervention · Île-de-France &amp; régions voisines
                    </div>
                    <div className="flex flex-wrap gap-x-6 gap-y-2 text-[12px] text-[#FAF9F6]/50">
                        {AREAS.map((a) => (
                            <span key={a}>{a}</span>
                        ))}
                    </div>
                </div>

                <div className="pt-8 flex flex-wrap items-center justify-between gap-4 text-[11px] tracking-widest uppercase text-[#FAF9F6]/40">
                    <div>© {year} CM RENOV · Tous droits réservés</div>
                    <div className="flex flex-wrap items-center gap-4">
                        <Link
                            to="/mentions-legales"
                            data-testid="footer-legal-link"
                            className="hover:text-[#B89C6A] transition-colors"
                        >
                            Mentions légales &amp; RGPD
                        </Link>
                        <span className="text-[#FAF9F6]/20">·</span>
                        <span>SIRET 938 168 044 00015</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
